// City + service data used by dynamic city and service-city pages

export const CITIES = [
  {
    slug: 'shreveport',
    name: 'Shreveport',
    state: 'LA',
    fullName: 'Shreveport, Louisiana',
    blurb: 'Our home base. From Highland to Southern Hills to Broadmoor, we install fences and decks across every neighborhood in Shreveport.',
    landmarks: ['Highland', 'South Highlands', 'Broadmoor', 'Southern Hills', 'University Terrace', 'Lakeside', 'Southern Trace'],
    lat: 32.5252, lng: -93.7502,
    primary: true,
  },
  {
    slug: 'bossier-city',
    name: 'Bossier City',
    state: 'LA',
    fullName: 'Bossier City, Louisiana',
    blurb: 'Just across the Red River from Shreveport, Bossier City is one of our top service areas — privacy fences, custom decks, and pool enclosures.',
    landmarks: ['Airline Drive', 'Barksdale', 'Palmetto', 'Legacy', 'Stockwell Place'],
    lat: 32.5160, lng: -93.7321,
    primary: true,
  },
  {
    slug: 'haughton',
    name: 'Haughton',
    state: 'LA',
    fullName: 'Haughton, Louisiana',
    blurb: 'Growing Bossier Parish town where we install a lot of wood privacy fences and custom decks for new construction.',
    landmarks: ['East 80', 'Sligo', 'Princeton'],
    lat: 32.5307, lng: -93.5041,
  },
  {
    slug: 'benton',
    name: 'Benton',
    state: 'LA',
    fullName: 'Benton, Louisiana',
    blurb: 'North of Bossier City, Benton neighborhoods often want ornamental iron front-yard fencing and estate gates — a specialty of ours.',
    landmarks: ['Cypress Bend', 'Willow Ridge', 'Lake Bistineau'],
    lat: 32.6949, lng: -93.7413,
  },
  {
    slug: 'mansfield',
    name: 'Mansfield',
    state: 'LA',
    fullName: 'Mansfield, Louisiana',
    blurb: 'DeSoto Parish seat where we install farm and ranch fencing plus wood privacy for lakefront properties.',
    landmarks: ['Toledo Bend', 'Old Fort Park'],
    lat: 32.0365, lng: -93.7002,
  },
  {
    slug: 'longview-tx',
    name: 'Longview',
    state: 'TX',
    fullName: 'Longview, Texas',
    blurb: 'East Texas metro where we install privacy fences, chain-link, and covered porches. Easy hop across the state line.',
    landmarks: ['Downtown Longview', 'Pine Tree', 'Spring Hill'],
    lat: 32.5007, lng: -94.7405,
  },
  {
    slug: 'marshall-tx',
    name: 'Marshall',
    state: 'TX',
    fullName: 'Marshall, Texas',
    blurb: 'Historic east Texas city where we build custom wood decks, board-on-board fences, and ornamental iron.',
    landmarks: ['Downtown Marshall', 'Wonder City', 'East End'],
    lat: 32.5449, lng: -94.3673,
  },
  {
    slug: 'waskom-tx',
    name: 'Waskom',
    state: 'TX',
    fullName: 'Waskom, Texas',
    blurb: 'Small Harrison County town on the LA-TX line — rural properties, farm fencing, and privacy installs.',
    landmarks: ['I-20 corridor', 'Highway 80'],
    lat: 32.4788, lng: -94.0577,
  },
  {
    slug: 'carthage-tx',
    name: 'Carthage',
    state: 'TX',
    fullName: 'Carthage, Texas',
    blurb: 'Panola County seat where we do a lot of ranch fencing, board-on-board privacy, and custom deck work.',
    landmarks: ['Downtown Carthage', 'Lake Murvaul'],
    lat: 32.1532, lng: -94.3379,
  },
  {
    slug: 'stonewall',
    name: 'Stonewall',
    state: 'LA',
    fullName: 'Stonewall, Louisiana',
    blurb: 'DeSoto Parish community south of Shreveport — growing subdivisions where we install privacy fences and pool decks.',
    landmarks: ['Wallace Lake', 'Old Mansfield Road'],
    lat: 32.2793, lng: -93.8199,
  },
  {
    slug: 'keithville',
    name: 'Keithville',
    state: 'LA',
    fullName: 'Keithville, Louisiana',
    blurb: 'Southwestern Caddo Parish area where wood fences, chain-link, and horse fencing are our bread and butter.',
    landmarks: ['Old Mooringsport Road'],
    lat: 32.3993, lng: -93.8683,
  },
  {
    slug: 'greenwood',
    name: 'Greenwood',
    state: 'LA',
    fullName: 'Greenwood, Louisiana',
    blurb: 'Western Caddo Parish town near the TX line — farm perimeter fencing, chain-link, and privacy fences.',
    landmarks: ['Greenwood Springs', 'I-20 corridor'],
    lat: 32.4432, lng: -93.9727,
  },
];

export const CITY_BY_SLUG = Object.fromEntries(CITIES.map(c => [c.slug, c]));

// Service-city top combos (only most important; a template renders each)
export const SERVICE_SLUGS = {
  'wood-fence': { title: 'Wood Fence Installation', service: 'Wood Fencing', keyword: 'wood fence installation' },
  'vinyl-fence': { title: 'Vinyl Fence Installation', service: 'Vinyl Fencing', keyword: 'vinyl fence installation' },
  'chain-link-fence': { title: 'Chain-Link Fence Installation', service: 'Chain-Link Fencing', keyword: 'chain link fence installation' },
  'iron-fence': { title: 'Ornamental Iron Fencing', service: 'Ornamental Iron', keyword: 'ornamental iron fence' },
  'deck-builder': { title: 'Custom Deck Builder', service: 'Deck Building', keyword: 'deck builder' },
  'ranch-fence': { title: 'Farm & Ranch Fencing', service: 'Farm & Ranch', keyword: 'farm ranch fence' },
};

// Which service pages we build per city (keep list manageable; can expand later)
export const SERVICE_CITY_COMBOS = [
  ['wood-fence', 'shreveport'],
  ['wood-fence', 'bossier-city'],
  ['wood-fence', 'longview-tx'],
  ['vinyl-fence', 'shreveport'],
  ['vinyl-fence', 'bossier-city'],
  ['chain-link-fence', 'shreveport'],
  ['chain-link-fence', 'bossier-city'],
  ['iron-fence', 'shreveport'],
  ['iron-fence', 'benton'],
  ['deck-builder', 'shreveport'],
  ['deck-builder', 'bossier-city'],
  ['deck-builder', 'haughton'],
  ['deck-builder', 'longview-tx'],
  ['ranch-fence', 'mansfield'],
  ['ranch-fence', 'carthage-tx'],
  ['ranch-fence', 'keithville'],
];
